import { render } from "./AdditionalServices.vue?vue&type=template&id=46b02b43&scoped=true&ts=true"
import script from "./AdditionalServices.vue?vue&type=script&lang=ts"
export * from "./AdditionalServices.vue?vue&type=script&lang=ts"

import "./AdditionalServices.vue?vue&type=style&index=0&id=46b02b43&scoped=true&lang=scss"
import "./AdditionalServices.vue?vue&type=style&index=1&id=46b02b43&lang=css"

import exportComponent from "/Users/bekircankaya/Documents/GitHub/kurban-vekalet-frontend-eski-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b02b43"]])

export default __exports__